export default [
  {
    title: 'Home',
    icon: 'HomeIcon',
    route: 'dashboard-ecommerce',
    resource: 'admin',
    action: 'manage',
  },
]
